import React from 'react';
import { Navigate } from 'react-router-dom';
import { store } from '../../App'
import { sides as authSides } from '../auth/reducer'
import CircularProgress from '@mui/material/CircularProgress'
import { connect } from 'react-redux'


class Authenticaded extends React.Component {

    state = { done: false }

    componentDidMount = () => {

        var state = store.getState()

        this.props.saveLoginInfo(state.auth.user)

        this.setState({ done: true })
    }

    render() {

        if (this.state.done) {
            return <Navigate to="/" replace />
        }

        return <CircularProgress />
    }

}

const mapStateToProps = (state) => {

    return state.auth;
}

const mapDispatchToProps = (dispatch) => {

    return {
        saveLoginInfo(user) {
            dispatch(authSides.saveLoginInfo(user))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Authenticaded)
